export default __webpack_public_path__ + "static/media/logo.7f69f8f8.png";